import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Tell Us The Vehicle You Want",
    body: "Make, model, year, budget, mileage, features. A quick note about the car you have in mind · that's all we need to start.",
  },
  {
    n: "02",
    title: "We Search For Your Match",
    body: "Our team searches our nationwide network and market sources to find real vehicles that fit your request.",
  },
  {
    n: "03",
    title: "We Review The Best Options",
    body: "Market pricing, vehicle condition, availability, and long-term value · every candidate is vetted before you see it.",
  },
  {
    n: "04",
    title: "You Choose Your Vehicle",
    body: "We present the curated options side-by-side, answer every question, and walk you through what makes each one worth it.",
  },
  {
    n: "05",
    title: "We Handle The Details",
    body: "Inspection, paperwork, financing options, and delivery or pickup · easy from selection to keys-in-hand.",
  },
];

const chapter = {
  hidden: { opacity: 0, y: 60 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.7, 0, 0.2, 1], delay: i * 0.06 },
  }),
};

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-section" className="relative py-28 lg:py-40 px-6 lg:px-10 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="flex items-baseline gap-4 mb-16 lg:mb-24"
        >
          <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#E31E24]">
            (Manifesto) · 01/05
          </span>
          <span className="flex-1 h-px bg-white/15 mt-1" />
          <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-white/50">
            Our Process
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.7, 0, 0.2, 1] }}
          className="font-anton uppercase leading-[0.9] text-[10vw] md:text-[7vw] lg:text-[5.5vw] mb-16 lg:mb-24"
        >
          How We <span className="font-cormorant italic font-medium text-[#E31E24]">source</span> a car
        </motion.h2>

        <div className="grid grid-cols-12 gap-y-16 lg:gap-y-24">
          {STEPS.map((s, i) => (
            <motion.article
              key={s.n}
              custom={i}
              variants={chapter}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`step-${s.n}`}
              className={`col-span-12 lg:col-span-10 grid grid-cols-12 gap-6 lg:gap-10 ${
                i % 2 === 1 ? "lg:col-start-3" : "lg:col-start-1"
              }`}
            >
              <div className="col-span-3 lg:col-span-2">
                <div className="font-anton text-[70px] lg:text-[110px] leading-none text-white/15">
                  {s.n}
                </div>
              </div>
              <div className="col-span-9 lg:col-span-10">
                <h3 className="font-anton uppercase text-3xl lg:text-5xl leading-[0.95] mb-4">
                  {s.title}
                </h3>
                <p className="text-white/65 max-w-2xl text-[15px] lg:text-lg leading-relaxed">
                  {s.body}
                </p>
                <div className="mt-6 h-px w-24 bg-[#E31E24]" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
